import React from 'react'

function DataAnalysis() {
  return (
    <div>
        <div className="container mx-auto px-4 py-24">
      <div className="bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-4">Unlock the Power of Data Analysis</h1>
        <p className="text-lg text-gray-700 mb-6">
          Join our Data Analysis Program and discover the secrets hidden in data!
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">What is Data Analysis?</h2>
        <p className="text-gray-700 mb-6">
          Data Analysis is the process of extracting insights and meaningful information from data to inform business decisions, drive growth, and optimize performance.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Data Analysis?</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>High demand for data analysts across industries</li>
          <li>Competitive salaries and benefits</li>
          <li>Opportunities for advancement and specialization</li>
          <li>Make data-driven decisions and drive business impact</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Data Analysis Program</h2>
        <p className="text-gray-700 mb-6">
          Our comprehensive program covers:
        </p>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Data visualization and communication</li>
          <li>Statistical analysis and modeling</li>
          <li>Data mining and machine learning</li>
          <li>Data governance and ethics</li>
          <li>Emerging trends: AI, IoT, and more</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Training Roadmap</h2>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 1: Foundations (3 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Introduction to Data Analysis</li>
          <li>Data Visualization (Tableau, Power BI)</li>
          <li>Statistical Analysis (R, Python)</li>
          <li>Data Wrangling and Preprocessing</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 2: Intermediate (6 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Data Mining and Machine Learning (Python, R)</li>
          <li>Data Warehousing and Business Intelligence</li>
          <li>Data Governance and Ethics</li>
          <li>SQL and NoSQL Databases</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 3: Advanced (9 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Advanced Machine Learning (TensorFlow, PyTorch)</li>
          <li>Data Science with Python and R</li>
          <li>Big Data Analytics (Hadoop, Spark)</li>
          <li>Data Storytelling and Communication</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-800 mb-2">Level 4: Specialization (3 months)</h3>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Choose from: Data Science, Business Intelligence, or Data Engineering</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Certifications</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Certified Data Analyst (CDA)</li>
          <li>Certified Analytics Professional (CAP)</li>
          <li>Google Data Analytics Certification</li>
          <li>Microsoft Certified: Data Analyst Associate</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Choose Our Program?</h2>
        <ul className="list-disc list-inside mb-6 text-gray-700">
          <li>Industry expert instructors</li>
          <li>Hands-on training and projects</li>
          <li>Flexible learning options (online, offline)</li>
          <li>Career support and placement assistance</li>
        </ul>

        <div className="mt-8 text-center">
          <p className="text-lg font-semibold text-gray-800">Get Ready to Unlock the Power of Data!</p>
          <p className="text-gray-700 mb-2">Contact us to learn more and enroll today.</p>
          <p className="text-gray-700">
            <strong>Email:</strong> dataanalysis@techeraafrica.com <br />
            <strong>Phone:</strong> 080 2263 2222
          </p>
          <a
            href="/brochure"
            className="mt-4 inline-block bg-blue-600 text-white font-semibold py-2 px-6 rounded-md shadow hover:bg-blue-700"
          >
            Download Our Brochure
          </a>
        </div>
      </div>
    </div>
    </div>
  )
}

export default DataAnalysis